<nb-card>
  <nb-card-header>
    <div class="row">
      <div class="col-12 form-inline">
        <nb-form-field fullWidth>
          <nb-icon nbPrefix icon="hash-outline"></nb-icon>
          <input
            type="number"
            nbInput
            fullWidth
            shape="semi-round"
            class="form-control"
            [(ngModel)]="quantity"
            (keydown.enter)="generator()"
          />
        </nb-form-field>

        <button
          nbButton
          hero
          status="success"
          size="small"
          (click)="generator()"
          [disabled]="quantity === 0 || !quantity"
        >
          <nb-icon nbPrefix icon="code-download-outline"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div id="print-section" class="print-layout">
      <div class="container">
        <div class="item" *ngFor="let item of numbers; let i = index">
          <ngx-view-barcode
            [id]="'barcode-' + i"
            [barcode]="product.barcode"
            [title]="product.title"
          >
          </ngx-view-barcode>
        </div>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <!--- This is hidden using CSS ----->
    <button
      type="button"
      class="btn btn-sm d-none"
      ngxPrint
      printSectionId="print-section"
      styleSheetFile="assets/css/layout-print-product-barcode.css"
      #printBtn
      ngxPrint
    >
      Auto Print
    </button>

    <button
      nbButton
      hero
      shape="semi-round"
      status="info"
      size="medium"
      (click)="print()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
      id="btnPrint"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      {{ "buttons.print" | translate }}
    </button>

    <button
      nbButton
      outline
      shape="semi-round"
      status="danger"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
      <span>{{ "buttons.close" | translate }}</span>
    </button>
  </nb-card-footer>
</nb-card>
